// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

let fadeOptions = {
    "duration": 400,
    "delay": 0
};

$w.onReady(function () {
    $w("#datasetGallery").onReady(() => {
        $w("#repeaterGallery").forEachItem(($item, itemData, index) => {
            $item("#imageItem").tooltip = ""
            $item("#boxItem").onMouseIn((event) => {
                $w("#boxHoverBlack").hide()
                    .then(() => {
                        // $item("#boxHoverBlack").show("fade", fadeOptions);
                        $item("#boxHoverBlack").show();

                    });

            });

            $item("#boxItem").onMouseOut((event) => {
                $item("#boxHoverBlack").hide();

            });
        });
    });

});